"use strict";

import { responseCodes } from "../_redux/_constants";

const customErrorMessages = (errorResponse) => {
    return errorResponse;
};

export { customErrorMessages };
